import { render, staticRenderFns } from "./AppSidebarRight.vue?vue&type=template&id=1f7660f0&"
import script from "./AppSidebarRight.vue?vue&type=script&lang=js&"
export * from "./AppSidebarRight.vue?vue&type=script&lang=js&"
import style0 from "./AppSidebarRight.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports